module.exports = __webpack_public_path__ + "img/odontodocs.ead8caf6.png";